import React from 'react';

import okkoLogoImg from '../img/OkkoLogo.jpg';
import skyengLogoImg from '../img/SkyengLogo.jpg';
import yandexMusicLogoImg from '../img/YandexMusicLogo.png';
import litresLogoImg from '../img/LitresLogo.png';
import courseraLogoImg from '../img/CourseraLogo.jpg';
import geekBrainsLogoImg from '../img/GeekBrainsLogo.jpg';
import arzamasLogoImg from '../img/ArzamasLogo.jpg';
import puzzleEnglishLogoImg from '../img/PuzzleEnglishLogo.png';
import skillboxLogoImg from '../img/SkillboxLogo.jpg';

export default function LeisureLanding() {
  return (
    <div className='content'>
      <div className='leisurecontent'>
        <div className='youtubevideo block'>
          <div className='description'>
            <h1>COVID-19: миф или реальность?</h1>
            <p>
            Данный видеоролик раз и навсегда развеет все мифы о новом 
            коронавирусе, появившемся в Китае, а также расскажет вам о 
            структуре вирусов, их возможности проникать в организм и заражать 
            клетки человеческого тела. Уверены в том, что противовирусные 
            препараты спасут вас от COVID-19? Тогда вам точно нужно посмотреть 
            этот видеоролик! Вы всё ещё тут? Бегом смотреть!</p>
          </div>
          <iframe src='https://www.youtube.com/embed/dukR1VXPR1s'
            frameBorder='0'
            allow='autoplay; encrypted-media'
            allowFullScreen
            title='video'
            className='youtubeiframe'
            />
        </div>

        <div className='yandexpodcast block'>
          <iframe 
            frameBorder='0'
            title='podcast'
            className='yandexiframe'
            src='https://music.yandex.ru/iframe/#album/8770943'
            />

          <div className='description'>
            <h1>Начните то, что давно хотели, но откладывали</h1>
            <p>Прослушайте данную серию подкастов, чтобы начать медитировать,
              что поможет вам добиться состояния внутренней сосредоточенности,
              самосозерцания и духовного прозрения. </p>
          </div>
        </div>

        <div className='adblock block okko'>
          <div 
            className='img'
            style={{
              backgroundImage: `url(${okkoLogoImg})`,
            }}
            >
          </div>
          <div className='addescription'>
            30 дней бесплатной VIP-подписки по промокоду FilmsQuarantine
          </div>
        </div>

        <div className='adblock block skyeng'>
          <div className='addescription'>
            3 занятия в подарок при покупке 7-ми дневного онлайн курса по промокоду AntiCorona
          </div>
          <div 
            className='img'
            style={{
              backgroundImage: `url(${skyengLogoImg})`,
            }}
            >
          </div>
          
        </div>

        <div className='adblock block yandex'>
          <div 
            className='img'
            style={{
              backgroundImage: `url(${yandexMusicLogoImg})`,
            }}
            >
          </div>
          <div className='addescription'>
            Слушай музыку бесплатно! Мы открыли бесплатный доступ всем пользователям на время карантина.
          </div>
        </div>

        <div className='adblock block litres'>
          <div className='addescription'>
            Нет лучшего подарка, чем книга! Именно поэтому мы дарим бесплатный доступ к более, чем 30000 книг!
          </div>
          <div 
            className='img'
            style={{
              backgroundImage: `url(${litresLogoImg})`,
            }}
            >
          </div>

        </div>

        <div className='adblock block coursera'>
          <div 
            className='img'
            style={{
              backgroundImage: `url(${courseraLogoImg})`,
            }}
            >
          </div>
          <div className='addescription'>
            До 31 июля образовательная платформа открыла доступ к более, чем 3800 курсов!
          </div>
        </div>
        <div className='adblock block geekbrains'>
          <div className='addescription'>
            Образовательный сервис GeekBrains на время карантина открывает доступ к курсам. Зарегистрируйтесь и ответьте на три вопроса об эпидемии.
          </div>
          <div 
            className='img'
            style={{
              backgroundImage: `url(${geekBrainsLogoImg})`,
            }}
            >
          </div>
          
        </div>

        <div className='adblock block arzamas'>
          <div 
            className='img'
            style={{
              backgroundImage: `url(${arzamasLogoImg})`,
            }}
            >
          </div>
          <div className='addescription'>
            Любой желающий может бесплатно получить месяц доступа ко всем материалам сервиса.
          </div>
        </div>
        <div className='adblock block puzzleenglish'>
          <div className='addescription'>
            100 бесплатных пазлов по промокоду ItsCoronaTime
          </div>
          <div 
            className='img'
            style={{
              backgroundImage: `url(${puzzleEnglishLogoImg})`,
            }}
            >
          </div>
        </div>
        <div className='adblock block skillbox'>
          <div 
            className='img'
            style={{
              backgroundImage: `url(${skillboxLogoImg})`,
            }}
            >
          </div>
          <div className='addescription'>
            Полный курс по программированию совершенно бесплатно по промокоду SkillAntiCorona
          </div>
        </div>
      </div>
    </div>
  );
}